/**
 * News Module
 * This is the main behavior file for News single pages and text-heavy pages (wall of text)
 * Handles:
 * - Table of contents generation from H2 headings
 * - Sticky table of contents positioning while scrolling
 * - Smooth scrolling to sections when clicking table of content links
 * - Only applies these behaviors for tablet/desktop viewports (>= 820px)
 */

export default class Specialty {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    // Handle load more specialties
    if (
      $(".section-specialties-list").length &&
      $("#loadmore-specialty-btn").length
    ) {
      $("#loadmore-specialty-btn").on("click", () => {
        // Get hidden specialty items
        const $hiddenItems = $(".specialty-item.hide");

        // Show next 6 items
        $hiddenItems.slice(0, 6).removeClass("hide");

        // Hide load more button if no more hidden items
        if ($hiddenItems.length <= 6) {
          $("#loadmore-specialty-btn").hide();
        }
      });
    }
  }
}
